export default "__VITE_ASSET__Bl2f6Yh0__"